import React from "react";
import { initialState } from "./hooks/useUserAssets";
const UserAssetContext = React.createContext({
    asset: false,
    userAssets: initialState,
    selectedUserAsset: false
});

export default UserAssetContext;
